import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';

export interface TagComponentValue {
    value: string;
    styleClass?: string;
    color?: TagColor;
    size?: TagSize;
}

export type TagColor = 'primary' | 'blue' | 'green' | 'yellow' | 'orange' | 'red' | 'purple' | 'pink' | 'teal' | 'cyan' | 'gray' | string;
export type TagSize = 'text-xs' | 'text-sm' | 'text-base' | 'text-lg'| string ;

@Component({
    selector: 'app-tag',
    template: `
        <span class="border-1 px-1 border-round {{size}} {{styleClass}}">{{ value }}</span>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagComponent implements OnChanges {
    @Input() value: string;
    @Input() styleClass: string;
    @Input() color: TagColor = 'primary';
    @Input() size: TagSize = 'text-xs';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.color) {
            this.styleClass = this.styleClass ?? `text-${this.color}-500`;
        }
    }
}
